import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { FieldActivityPlan } from '../_models/fieldActivityPlan';

@Injectable()
export class FieldActivityPlanService {
  private apiBaseUrl = environment.apiBaseUrl;
  planItemObj: BehaviorSubject<FieldActivityPlan> = new BehaviorSubject<FieldActivityPlan>(null);

  constructor(private http: HttpClient) {}

  // Ottiene tutti i Field Activity Plans
  getFieldActivityPlans(): Observable<FieldActivityPlan[]> {
    return this.http.get<FieldActivityPlan[]>(
      `${this.apiBaseUrl}api/private/v1/fieldActivityPlans`
    );
  }

  // Ottiene i Field Activity Plans filtrati per tipo
  getFieldActivityPlansByType(type: any): Observable<FieldActivityPlan[]> {
    return this.http.get<FieldActivityPlan[]>(
      `${this.apiBaseUrl}api/private/v1/fieldActivityPlans?type=${type}`
    );
  }

  // Ottiene un singolo Field Activity Plan per id
  getFieldActivityPlan(id: number): Observable<FieldActivityPlan> {
    return this.http.get<FieldActivityPlan>(
      `${this.apiBaseUrl}api/private/v1/fieldActivityPlans/${id}`
    );
  }

  // Salva un Field Activity Plan (crea o aggiorna)
  saveFieldActivityPlan(
    fieldActivityPlanItem: FieldActivityPlan,
    generateFieldActivities: boolean = false
  ): Observable<FieldActivityPlan> {
    const fieldActivityPlan = { ...fieldActivityPlanItem };
    delete fieldActivityPlan.lastUpdated;
    delete fieldActivityPlan.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    fieldActivityPlan.companyId = companySelected ? companySelected.id : null;

    if (fieldActivityPlan.id) {
      return this.http.put<FieldActivityPlan>(
        `${this.apiBaseUrl}api/private/v1/fieldActivityPlans/${fieldActivityPlan.id}?generateFieldActivities=${generateFieldActivities}`,
        fieldActivityPlan
      );
    } else {
      return this.http.post<FieldActivityPlan>(
        `${this.apiBaseUrl}api/private/v1/fieldActivityPlans?generateFieldActivities=${generateFieldActivities}`,
        fieldActivityPlan
      );
    }
  }

  // Elimina un Field Activity Plan
  deleteFieldActivityPlan(fieldActivityPlan: FieldActivityPlan): Observable<FieldActivityPlan> {
    return this.http
      .delete<void>(`${this.apiBaseUrl}api/private/v1/fieldActivityPlans/${fieldActivityPlan.id}`)
      .pipe(map(() => ({ id: fieldActivityPlan.id }) as FieldActivityPlan));
  }
}
